import { decimalNumberTool } from "./decimal-number.tool";

export const percentFormatterTool = (num: number): string => {
  if (num === undefined || num === null) return "";
  return `${decimalNumberTool(num)}%`;
};
